import React from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Clarity from '@microsoft/clarity';

const CLARITY_ID = process.env.REACT_APP_CLARITY_ID;

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen bg-white">
    <div className="animate-spin h-12 w-12 border-4 border-black border-t-transparent rounded-full"></div>
  </div>
);

const isProfileComplete = (profile) => {
  // Check if profile exists and has profileCompleted field set to true
  return profile && 
         typeof profile === 'object' && 
         'profileCompleted' in profile && 
         profile.profileCompleted === true;
};

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, isLoading, userId, userProfile } = useAuth();

  React.useEffect(() => {
    if (!isLoading) {
      if (!token || !userId) {
        navigate('/login', { replace: true });
      } else if ((!userProfile || !isProfileComplete(userProfile)) && location.pathname !== '/onboarding') {
        // Redirect to onboarding if profile is null or incomplete
        navigate('/onboarding', { replace: true });
      }
    }
  }, [isLoading, token, userId, userProfile, navigate, location.pathname]);

  if (isLoading || !userId) {
    return <LoadingFallback />;
  }

  // Allow access to onboarding page even if profile is null or incomplete
  if (location.pathname === '/onboarding') {
    return <Outlet />;
  }
  
  // For other protected routes, check if profile is complete
  if (!userProfile || !isProfileComplete(userProfile)) {
    return <LoadingFallback />;
  }

  if (isProfileComplete(userProfile) && process.env.NODE_ENV === 'production' && CLARITY_ID && userId) {
    Clarity.identify(userId);
  }

  return <Outlet />;
};

export default ProtectedRoute; 